import { watch } from 'vue'
import { setEventServiceUserId } from '@/libs/events/events'
import { useWhoAmI } from './whoAmI'

/**
 * Composable that reactively syncs the current user's entityId to the event
 * service client whenever it changes, so emitted events carry the actor id.
 * Mirrors useDatadogUser.
 */
export function useEventServiceUser() {
  const { selfEntityId } = useWhoAmI()

  watch(selfEntityId, (newId) => {
    setEventServiceUserId(newId)
  })
}
